/**
 * Whether a post's title is worth drawing above its body.
 *
 * ONE ANSWER, because there used to be two and they disagreed. `PostCard` and
 * `ImageLightbox` each carried their own version of this, and the lightbox's
 * still tested for a UUID:
 *
 *     /^(post-)?[0-9a-f]{8}-[0-9a-f]{4}-…/.test(titleText)
 *
 * That guard was deliberately dropped from the card when v1 landed. `title` is
 * `string | null` and means it (C3) — the 55,049 `crypto.randomUUID()` titles
 * that existed only because a post required a topic and a topic required a
 * title are not on the v1 wire, so there is nothing left to detect. The
 * lightbox kept running the dead regex, which meant the same post could show
 * its title on one surface and hide it on the other.
 *
 * What remains is the real rule: a title that merely restates the opening of
 * the body is noise. The trailing ellipsis comes off first, because an excerpt
 * is truncated and the title it was cut from is not.
 */
export function showPostTitle(post: { title?: string | null; excerpt?: string | null }): boolean {
  const excerptText = (post.excerpt ?? "").trim();
  const titleText = (post.title ?? "").trim();
  if (titleText.length === 0) return false;

  const titleForCompare = titleText.replace(/…$/, "").trim();
  const isPrefixTitle = excerptText.startsWith(titleForCompare) || titleText === excerptText;
  return !isPrefixTitle;
}
